import React,{useState} from 'react'
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js'
import { envAwarePost } from "../../util/util";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";


const makePaymentMethodDefault = (payment_method_id)=>(
	envAwarePost('/api/user/api.php',{
		action:'makePaymentMethodDefault',
		payment_method_id
	})
)

const PaymentModal = ({show,toggle,refresh})=>{
	const stripe = useStripe()
	const elements = useElements()
	const [status,setStatus] = useState('idle')
	const confirmSetup = ()=>(
		stripe.confirmSetup({
			elements,
			confirmParams: {
				return_url: 'https://www.fitsw.com',
			},
			redirect:'if_required'
		})
	)
	const handleSubmit = async (event) => {
		setStatus('loading')
		// Block native form submission.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

	
		
		confirmSetup()
		.then(res=>{
			if(res.error) throw new Error(res.error.message)
			if(res.setupIntent.status !== 'succeeded') throw new Error("Something went wrong. Please, try again")
			return makePaymentMethodDefault(res.setupIntent.payment_method)
		}).then(res=>{
			if( res.success != 1 ) throw new Error(res.message)
			refresh()
			setStatus('idle')
			toggle()
		}).catch(err=>{
			setStatus('idle')
			window.alert(err)
		})

	}
	return (
		<Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
            <Modal.Title>Update Payment Info</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PaymentElement
                    options={{
                    	hidePostalCode:true,
                        style: {
                            base: {
                                fontSize: '16px',
                                color: '#424770',
                                    '::placeholder': {
                                    color: '#aab7c4',
                                },
                            },
                            invalid: {
                                color: '#9e2146',
                            },
                        },
                    }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button size="sm" variant="secondary" onClick={toggle}>
                    Cancel
                </Button>
                <Button size="sm" 
                	disabled={status==='loading'}
                	onClick={handleSubmit} 
                	variant="primary"
                >
                    {	
                    	status === 'loading' ?
                    	<Spinner animation="border" size="sm"/> : 
                    	"Save New Card"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
	)
}

export default PaymentModal